/* CsakCsajok – termékoldal élmény (sections/cc-pdp.liquid).
   Leírás-elemző (gyártói adatok), áttekintő számok, zóna-iránytű, rezgés-szimulátor, méret-vizualizáló
   (bankkártyás kalibrálással), specifikáció, lépések, síkosító-választó, ajánlók (Shopify recommendations
   + kollekció-tartalék) szűrővel és összevetéssel, kosárba, fejezet-navigáció, GYIK, várható kézbesítés. */
(() => {
  'use strict';
  if (window.__ccPdp) return;
  window.__ccPdp = true;

  const html = document.documentElement;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wide = matchMedia('(min-width: 750px)');
  const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const huNum = (n, d) => {
    const v = Number(n);
    if (!isFinite(v)) return '';
    const dd = d == null ? (Math.abs(v - Math.round(v)) < 0.05 ? 0 : 1) : d;
    return v.toFixed(dd).replace('.', ',');
  };
  const ft = (cents) => String(Math.round((Number(cents) || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  const json = (el, fb) => { try { return JSON.parse(el && el.textContent || ''); } catch (e) { return fb; } };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ================= várható kézbesítés a vásárlódobozban ================= */
  (function eta() {
    const li = $$('.cc-bb__trust li').find((l) => /munkanap/i.test(l.textContent));
    if (!li) return;
    const HOL = ['2026-01-01', '2026-03-15', '2026-04-03', '2026-04-06', '2026-05-01', '2026-05-25', '2026-08-20', '2026-10-23', '2026-11-01', '2026-12-24', '2026-12-25', '2026-12-26',
      '2027-01-01', '2027-03-15', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-17', '2027-08-20', '2027-10-23', '2027-11-01', '2027-12-24', '2027-12-25', '2027-12-26'];
    const MON = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];
    let now;
    try {
      const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      now = new Date(p + 'T12:00:00');
    } catch (e) { now = new Date(); }
    const key = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    const isBiz = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !HOL.includes(key(d));
    const addBiz = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (isBiz(x)) k++; } return x; };
    const a = addBiz(now, 1), b = addBiz(now, 2);
    const txt = a.getMonth() === b.getMonth()
      ? MON[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() + '.'
      : MON[a.getMonth()] + ' ' + a.getDate() + '. – ' + MON[b.getMonth()] + ' ' + b.getDate() + '.';
    const svg = li.querySelector('svg');
    li.innerHTML = '';
    if (svg) li.appendChild(svg);
    li.insertAdjacentHTML('beforeend', '<span>Várható kézbesítés: <b class="ccp-eta">' + txt + '</b></span>');
    li.title = 'DHL futárral, általában 1–3 munkanap';
  })();

  const root = $('[data-ccp]');
  if (!root) return;
  html.classList.add('ccp-js');

  const curPrice = Number(root.dataset.price) || 0;
  const curTypes = (root.dataset.tipus || '').split('|').filter(Boolean);
  const curVendor = (root.dataset.vendor || '').trim().toLowerCase();
  let current = {};
  try { current = JSON.parse(root.dataset.current || '{}'); } catch (e) { current = {}; }

  // A cikkszám a méret-vizualizáló nélkül is követi a kiválasztott változatot.
  const skuVariants = json($('[data-ccp-variants]', root), {});
  let lastSkuVariant = null;
  const syncSku = () => {
    const form = $('.js-main-product-form input[name="id"]') || $('form[action*="/cart/add"] input[name="id"]');
    const variant = form && skuVariants[form.value];
    if (!variant || form.value === lastSkuVariant) return;
    lastSkuVariant = form.value;
    $$('[data-ccp-sku]', root).forEach((el) => {
      el.textContent = variant.s || '';
      if (el.parentElement) el.parentElement.hidden = !variant.s;
    });
  };
  setInterval(syncSku, 500);
  syncSku();

  /* ================= reveal + számláló ================= */
  const countUp = (el) => {
    const to = parseFloat(String(el.dataset.ccpCount).replace(',', '.'));
    if (!isFinite(to) || reduce) { el.textContent = huNum(to); return; }
    const dec = Math.abs(to - Math.round(to)) < 0.05 ? 0 : 1;
    const t0 = performance.now(), dur = 1100;
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - k, 3);
      el.textContent = huNum(to * e, dec);
      if (k < 1) requestAnimationFrame(step);
    };
    el.textContent = huNum(0, dec);
    requestAnimationFrame(step);
  };
  let revealIO = null;
  const onReveal = (el) => {
    el.classList.add('is-in');
    $$('[data-ccp-count]', el).forEach(countUp);
    el.dispatchEvent(new CustomEvent('ccp:in'));
  };
  const observe = (el) => {
    if (revealIO) revealIO.observe(el); else onReveal(el);
  };
  if ('IntersectionObserver' in window && !reduce) {
    revealIO = new IntersectionObserver((es) => {
      es.forEach((en) => { if (en.isIntersecting) { revealIO.unobserve(en.target); onReveal(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
  }
  $$('[data-ccp-r]', root).forEach(observe);

  /* ================= leírás-elemző (gyártói adatok) ================= */
  const parseDesc = () => {
    const rte = $('.main-product .product__description .rte') || $('.product__description .rte');
    if (!rte) return {};
    const src = rte.innerHTML
      .replace(/<(br|\/p|\/li|\/div|\/h\d|\/tr|\/td|\/dt|\/dd)[^>]*>/gi, '\n')
      .replace(/<li[^>]*>/gi, '\n');
    const tmp = document.createElement('div');
    tmp.innerHTML = src;
    let t = (tmp.textContent || '').replace(/ /g, ' ').replace(/\t/g, '\n');
    const N = '(\\d+(?:[.,]\\d+)?)';
    const num = (s) => parseFloat(String(s).replace(',', '.'));
    const toCm = (v, u) => (/mm/i.test(u) ? v / 10 : /in/i.test(u) ? v * 2.54 : v);
    const W = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, eleven: 11, twelve: 12, fifteen: 15, twenty: 20, dos: 2, tres: 3, cuatro: 4, cinco: 5, seis: 6, siete: 7, ocho: 8, nueve: 9, diez: 10, doce: 12 };
    t = t.replace(/\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|fifteen|twenty|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez|doce)\b(?=\s+(?:different\s+|powerful\s+|versatile\s+|vibration\s+|intense\s+)*(?:modes|settings|programs|patterns|speeds|motors|intensit|modos|programas|velocidades|motores))/gi, (m) => String(W[m.toLowerCase()]));
    const f = {};
    let m;

    m = t.match(new RegExp('(?:insertable length|insertion length|longitud insertable|longitud de inserci[oó]n|longitud introducible|einf[uü]hrbare l[aä]nge|behelyezhet[oő] hossz(?:a|úság)?|longueur ins[eé]rable)\\s*[:\\-–]?\\s*(?:approx\\.?|aprox\\.?|ca\\.?|kb\\.?|~)?\\s*' + N + '\\s*(mm|cm)', 'i'));
    if (m) { f.ins = toCm(num(m[1]), m[2]); t = t.replace(m[0], ' '); }

    m = t.match(new RegExp('(?:size|dimensions?|medidas|dimensiones|tama[nñ]o|abmessungen|ma[ßs]e|m[eé]ret(?:ek)?)\\s*[:\\-–]?\\s*' + N + '\\s*(?:mm|cm)?\\s*[x×*]\\s*' + N + '(?:\\s*(?:mm|cm)?\\s*[x×*]\\s*' + N + ')?\\s*(mm|cm)', 'i'));
    if (m) {
      const dims = [m[1], m[2], m[3]].filter(Boolean).map((v) => toCm(num(v), m[4])).sort((a, b) => b - a);
      f.tot = dims[0]; f.dims = dims;
    }
    if (!f.tot) {
      m = t.match(new RegExp('(?:total length|overall length|longitud total|largo total|gesamtl[aä]nge|teljes hossz(?:a|úság)?|length|longitud|largo|l[aä]nge|hossz(?:a|úság)?)\\s*[:\\-–]?\\s*(?:approx\\.?|aprox\\.?|ca\\.?|kb\\.?|~)?\\s*' + N + '\\s*(mm|cm)', 'i'));
      if (m) f.tot = toCm(num(m[1]), m[2]);
    }
    const dre = new RegExp('((?:max(?:imum|imal)?\\.?\\s*|m[aá]x\\.?\\s*)?(?:diameter|di[aá]metro|durchmesser|[aá]tm[eé]r[oő](?:je)?)[^:\\d\\n]{0,24})[:\\-–]?\\s*(?:approx\\.?|aprox\\.?|ca\\.?|kb\\.?|~)?\\s*' + N + '\\s*(mm|cm)', 'gi');
    while ((m = dre.exec(t))) {
      if (/base|talp|basis|sockel|suction|ventosa|ring|anillo|opening|apertura|nyílás/i.test(m[1])) continue;
      const v = toCm(num(m[2]), m[3]);
      if (v > 0.5 && v < 15 && (!f.dia || v > f.dia)) f.dia = v;
    }
    m = t.match(new RegExp('(?:weight|peso|gewicht|s[uú]ly(?:a)?|t[oö]meg(?:e)?)\\s*[:\\-–]?\\s*(?:approx\\.?|aprox\\.?|ca\\.?|kb\\.?|~)?\\s*' + N + '\\s*(kg|g|gr|grams?|gramos|gramm)\\b', 'i'));
    if (m) f.wt = /kg/i.test(m[2]) ? num(m[1]) * 1000 : num(m[1]);

    const H = '(h|hrs?|hours?|horas?|ore|óra|min|mins|minutes?|minutos?|perc)';
    const toMin = (v, u) => (/^(min|perc)/i.test(u) ? v : v * 60);
    m = t.match(new RegExp('(?:use time|usage time|run ?time|operating time|play ?time|tiempo de (?:uso|usuario|funcionamiento)|duraci[oó]n|duration|autonom[ií]a|laufzeit|[uü]zemid[oő]|haszn[aá]lati id[oő]|m[uű]k[oö]d[eé]si id[oő]|in use)\\s*[:\\-–]?\\s*(?:up to|hasta|max\\.?|kb\\.?|approx\\.?|aprox\\.?|bis zu|ca\\.?)?\\s*' + N + '(?:\\s*[-–]\\s*' + N + ')?\\s*' + H + '\\b', 'i'));
    if (!m) m = t.match(new RegExp('up to\\s*' + N + '()\\s*' + H + '\\s*(?:of\\s*)?(?:use|play|pleasure|playtime|run)', 'i'));
    if (m) f.use = toMin(num(m[2] || m[1]), m[3]);
    m = t.match(new RegExp('(?:charg(?:e|ing)(?: time)?|tiempo de carga|carga|ladezeit|t[oö]lt[eé]si id[oő]|t[oö]lt[eé]s(?:i ideje)?)\\s*[:\\-–]?\\s*(?:up to|hasta|max\\.?|kb\\.?|approx\\.?|aprox\\.?|ca\\.?)?\\s*' + N + '(?:\\s*[-–]\\s*' + N + ')?\\s*' + H + '\\b', 'i'));
    if (m) f.chg = toMin(num(m[2] || m[1]), m[3]);

    m = t.match(new RegExp('(?:noise(?: level)?|max(?:imum)? (?:level )?noise|nivel de ruido|ruido|ger[aä]uschpegel|lautst[aä]rke|zajszint|hanger[oő])\\s*[:\\-–]?\\s*(?:max\\.?|m[aá]x\\.?)?\\s*[<≤]?\\s*' + N + '\\s*db', 'i'));
    if (!m) m = t.match(new RegExp('[<≤]\\s*' + N + '\\s*db\\b', 'i'));
    if (m) f.db = num(m[1]);

    const modeRe = new RegExp(N.replace('(?:[.,]\\d+)?', '') + '\\s*(?:\\+\\s*\\d+\\s*)?(?:different\\s+|powerful\\s+|versatile\\s+|exquisite\\s+|unique\\s+|intense\\s+|vibration\\s+|vibrating\\s+|pulsation\\s+|stimulation\\s+|de\\s+)*(modes|settings|programs|programmes|patterns|functions|rhythms|modos|programas|patrones|funciones|ritmos|rezg[eé]sm[oó]d(?:dal)?|rezg[eé]si m[oó]d|rezg[eé]sprogram(?:mal)?|program(?:mal|ot)?|m[oó]d(?:dal|ot)?|vibrationsmodi|modi)\\b', 'gi');
    let best = 0;
    while ((m = modeRe.exec(t))) { const v = parseInt(m[1], 10); if (v > best && v <= 40) best = v; }
    m = t.match(/(?:modes|modos|programs|programas|m[oó]dok)\s*[:\-–]\s*(\d{1,2})\b/i);
    if (m && parseInt(m[1], 10) > best) best = parseInt(m[1], 10);
    if (best > 1) f.modes = best;
    const spRe = /(\d{1,2})\s*(?:different\s+|vibration\s+)*(speeds|intensity levels|intensities|levels of intensity|velocidades|intensidades|niveles de intensidad|fokozat(?:tal)?|sebess[eé]g(?:gel)?|intenzit[aá]s(?:i szint)?)\b/gi;
    best = 0;
    while ((m = spRe.exec(t))) { const v = parseInt(m[1], 10); if (v > best && v <= 30) best = v; }
    if (best > 1) f.speeds = best;
    m = t.match(/(\d)\s*(?:independent\s+|powerful\s+|super-strong\s+|power\s+|built-in\s+)*(?:motors|engines|motores|motorral|motor)\b/i) || t.match(/(?:motors|engines|motores)\s*[:\-–]\s*(\d)/i);
    if (m && parseInt(m[1], 10) > 1) f.mot = parseInt(m[1], 10);
    m = t.match(/IPX\s?-?([4-8])/i);
    if (m) f.ipx = 'IPX' + m[1];
    m = t.match(/(\d{1,2})[\s-]*(?:year|years|a[nñ]os?|jahre|[eé]v(?:es)?)\s*(?:limited\s+)?(?:warranty|garant[ií]a|garantie|garancia|guarantee)/i) || t.match(/(?:warranty|garant[ií]a|garantie|garancia)\s*[:\-–]?\s*(\d{1,2})\s*(?:year|years|a[nñ]os?|jahre|[eé]v)/i);
    if (m) f.war = parseInt(m[1], 10);
    m = t.match(new RegExp('(?:li-?ion|li-?lon|lithium|lipo|li-?po)[^\\n]{0,24}?' + N + '\\s*mah', 'i')) || t.match(new RegExp('(?:battery|bater[ií]a|akkumul[aá]tor|akku)\\s*[:\\-–]?[^\\n]{0,24}?' + N + '\\s*mah', 'i'));
    if (m) f.mah = Math.round(num(m[1]));
    return f;
  };
  const facts = parseDesc();
  const fmtTime = (min) => (min >= 60 ? huNum(min / 60) + ' óra' : Math.round(min) + ' perc');

  /* ================= áttekintés: számkártyák ================= */
  const stats = $('[data-ccp-stats]', root);
  if (stats) {
    const have = new Set($$('.ccp-stat', stats).map((s) => s.dataset.k));
    const add = [];
    const card = (k, valHtml, label) => {
      if (have.has(k)) return;
      have.add(k);
      add.push('<div class="ccp-stat is-new" data-k="' + k + '"><b>' + valHtml + '</b><span>' + label + '</span></div>');
    };
    const cnt = (v, unit, pre) => (pre ? '<small>' + pre + '</small>' : '') + '<span data-ccp-count="' + v + '">' + huNum(v) + '</span>' + (unit ? '<small>' + unit + '</small>' : '');
    if (!have.has('len') && facts.ins) card('len', cnt(facts.ins, 'cm'), 'behelyezhető hossz');
    if (!have.has('dia') && facts.dia) card('dia', cnt(facts.dia, 'cm', 'Ø'), 'legnagyobb átmérő');
    if (facts.modes) card('modes', cnt(facts.modes, ''), 'rezgésmód' + (facts.speeds ? ' · ' + facts.speeds + ' fokozat' : ''));
    else if (facts.speeds) card('modes', cnt(facts.speeds, ''), 'erősségfokozat');
    if (facts.use) card('use', facts.use >= 60 ? cnt(+(facts.use / 60).toFixed(1), 'óra') : cnt(Math.round(facts.use), 'perc'), 'játékidő egy töltéssel');
    if (facts.db) card('db', cnt(facts.db, 'dB'), 'max. zajszint');
    if (facts.mot) card('mot', cnt(facts.mot, ''), 'külön motor');
    if (!have.has('len') && !facts.ins && facts.tot) card('tot', cnt(facts.tot, 'cm'), 'teljes hossz');
    if (facts.wt) card('wt', cnt(Math.round(facts.wt), 'g'), 'súly');
    if (add.length) {
      const free = Math.max(0, 8 - $$('.ccp-stat', stats).length);
      stats.insertAdjacentHTML('beforeend', add.slice(0, free).join(''));
      const note = $('[data-ccp-statnote]', root);
      if (note) note.hidden = false;
      const ch = stats.closest('[data-ccp-r]');
      if (ch && ch.classList.contains('is-in')) $$('.ccp-stat.is-new [data-ccp-count]', stats).forEach(countUp);
    }
    if (!$$('.ccp-stat', stats).length) { const ch = stats.closest('.ccp-ch'); if (ch) ch.remove(); }
  }

  /* ================= specifikáció ================= */
  const spec = $('[data-ccp-spec]', root);
  if (spec) {
    const rows = [];
    const has = (k) => !!spec.querySelector('[data-k="' + k + '"]');
    if (facts.dims && facts.dims.length >= 2) rows.push(['Teljes méret', facts.dims.map((d) => huNum(d)).join(' × ') + ' cm']);
    else if (facts.tot) rows.push(['Teljes hossz', huNum(facts.tot) + ' cm']);
    if (facts.ins && !has('len')) rows.push(['Behelyezhető hossz', huNum(facts.ins) + ' cm']);
    if (facts.dia && !has('dia')) rows.push(['Legnagyobb átmérő', huNum(facts.dia) + ' cm']);
    if (facts.wt) rows.push(['Súly', Math.round(facts.wt) + ' g']);
    if (facts.modes) rows.push(['Rezgésmódok', facts.modes + ' db']);
    if (facts.speeds) rows.push(['Erősségfokozatok', facts.speeds + ' db']);
    if (facts.mot) rows.push(['Motorok', facts.mot + ' db']);
    if (facts.use) rows.push(['Üzemidő', 'akár ' + fmtTime(facts.use)]);
    if (facts.chg) rows.push(['Töltési idő', 'kb. ' + fmtTime(facts.chg)]);
    if (facts.mah) rows.push(['Akkumulátor', facts.mah + ' mAh']);
    if (facts.db) rows.push(['Zajszint', 'max. ' + huNum(facts.db) + ' dB']);
    if (facts.ipx) rows.push(['Vízállóság', facts.ipx]);
    if (facts.war) rows.push(['Gyártói garancia', facts.war + ' év']);
    const box = $('[data-ccp-specx]', root);
    const list = $('[data-ccp-specx-list]', root);
    if (rows.length && box && list) {
      list.innerHTML = rows.map((r) => '<div class="is-x"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>').join('');
      box.hidden = false;
    }
    // mobilon hosszú lista: 7 sor után „Összes adat”
    const all = $$('.ccp-spec__list > div', root);
    const more = $('[data-ccp-spec-more]', root);
    const sp = spec.closest('.ccp-spec');
    const LIM = 9;
    if (all.length > LIM + 1 && more && sp && !wide.matches) {
      all.slice(LIM).forEach((d) => d.classList.add('is-more'));
      sp.classList.add('is-clamped');
      const xs = $$('[data-ccp-specx-list] > div', root);
      if (box && xs.length && xs.every((d) => d.classList.contains('is-more'))) box.classList.add('is-more');
      more.hidden = false;
      more.textContent = 'Összes adat (' + all.length + ')';
      more.addEventListener('click', () => {
        const open = sp.classList.toggle('is-clamped');
        more.setAttribute('aria-expanded', String(!open));
        more.textContent = open ? 'Összes adat (' + all.length + ')' : 'Kevesebb';
      });
    }
  }

  /* ================= zóna-iránytű ================= */
  const wheel = $('[data-ccp-wheel]', root);
  if (wheel) {
    const data = json($('[data-ccp-zones-data]', root), { active: [], all: [], info: {} });
    const segG = $('[data-ccp-segs]', wheel);
    const SHORT = { 'Páros játék': 'Páros', 'Test, masszázs': 'Test' };
    const all = data.all || [];
    const n = all.length;
    const R1 = 80, R2 = 124, GAP = 2.2;
    const pt = (r, a) => [r * Math.cos(a), r * Math.sin(a)];
    let out = '';
    all.forEach((z, i) => {
      const a0 = ((i / n) * 360 - 90 + GAP / 2) * Math.PI / 180;
      const a1 = (((i + 1) / n) * 360 - 90 - GAP / 2) * Math.PI / 180;
      const [x0, y0] = pt(R2, a0), [x1, y1] = pt(R2, a1), [x2, y2] = pt(R1, a1), [x3, y3] = pt(R1, a0);
      const on = data.active.includes(z);
      const am = (a0 + a1) / 2;
      const [lx, ly] = pt((R1 + R2) / 2, am);
      const lab = SHORT[z] || z;
      out += '<path class="ccp-seg-arc' + (on ? ' is-on' : '') + '" data-z="' + esc(z) + '" style="transition-delay:' + (on ? i * 60 : 0) + 'ms" d="M' + x0.toFixed(2) + ' ' + y0.toFixed(2) + ' A' + R2 + ' ' + R2 + ' 0 0 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2) + ' L' + x2.toFixed(2) + ' ' + y2.toFixed(2) + ' A' + R1 + ' ' + R1 + ' 0 0 0 ' + x3.toFixed(2) + ' ' + y3.toFixed(2) + 'Z"' + (on ? ' role="button" tabindex="0" aria-label="' + esc(z) + '"' : ' aria-hidden="true"') + '></path>';
      out += '<text class="ccp-seg-lab ' + (on ? 'is-on' : 'is-off') + '" data-zl="' + esc(z) + '" x="' + lx.toFixed(1) + '" y="' + ly.toFixed(1) + '">' + esc(lab) + '</text>';
    });
    segG.innerHTML = out;
    const chips = $$('[data-ccp-zone]', root);
    const zt = $('[data-ccp-zt]', root), zd = $('[data-ccp-zd]', root), zc = $('[data-ccp-zcard]', root);
    const select = (z) => {
      const info = data.info[z] || { t: z, d: '' };
      $$('.ccp-seg-arc', segG).forEach((p) => p.classList.toggle('is-sel', p.dataset.z === z));
      $$('.ccp-seg-lab', segG).forEach((t) => t.classList.toggle('is-sel', t.dataset.zl === z));
      chips.forEach((c) => c.setAttribute('aria-selected', String(c.dataset.ccpZone === z)));
      if (zt) zt.textContent = info.t;
      if (zd) zd.textContent = info.d;
      if (zc) { zc.classList.remove('is-swap'); void zc.offsetWidth; zc.classList.add('is-swap'); }
    };
    chips.forEach((c) => c.addEventListener('click', () => select(c.dataset.ccpZone)));
    segG.addEventListener('click', (e) => { const p = e.target.closest('.ccp-seg-arc.is-on'); if (p) select(p.dataset.z); });
    segG.addEventListener('keydown', (e) => { const p = e.target.closest('.ccp-seg-arc.is-on'); if (p && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); select(p.dataset.z); } });
    if (data.active[0]) select(data.active[0]);
  }

  /* ================= rezgés-szimulátor ================= */
  const vibe = $('[data-ccp-vibe]', root);
  if (vibe) {
    const line = $('.ccp-vibe__line', vibe), ghost = $('.ccp-vibe__ghost', vibe), orb = $('.ccp-vibe__orb', vibe);
    const intEl = $('[data-ccp-int]', vibe), intOut = $('[data-ccp-int-out]', vibe);
    const buzz = $('[data-ccp-buzz]', vibe), buzzL = $('[data-ccp-buzz-l]', vibe);
    const pats = $$('[data-ccp-pat]', vibe);
    const modesEl = $('[data-ccp-modes]', vibe);
    if (modesEl && (facts.modes || facts.speeds)) {
      modesEl.hidden = false;
      modesEl.innerHTML = facts.modes
        ? '<b>' + facts.modes + '</b> rezgésmód' + (facts.speeds ? ' · <b>' + facts.speeds + '</b> fokozat' : '') + ' a játékban'
        : '<b>' + facts.speeds + '</b> erősségfokozat a játékban';
    }
    let pat = (pats.find((b) => b.getAttribute('aria-checked') === 'true') || pats[0]).dataset.ccpPat;
    let lvl = 3;
    const ENV = {
      steady: () => 1,
      pulse: (t) => { const ph = (t * 1.8) % 1; return ph < 0.5 ? 1 : 0.06; },
      wave: (t) => 0.5 + 0.5 * Math.sin(t * 2.4),
      rise: (t) => { const ph = (t / 3.2) % 1; return 0.12 + 0.88 * ph; },
      air: (t) => 0.5 + 0.5 * Math.sin(t * 7),
      heart: (t) => { const ph = (t * 1.25) % 1; return ph < 0.13 ? 1 : ph < 0.24 ? 0.08 : ph < 0.37 ? 0.72 : 0.05; },
      patter: (t) => ((t * 9) % 1 < 0.55 ? 1 : 0.12),
      steps: (t) => [0.28, 0.52, 0.76, 1][Math.floor((t / 1.1) % 4)]
    };
    const setFill = () => { intEl.style.setProperty('--fill', ((lvl - 1) / 4 * 100) + '%'); if (intOut) intOut.textContent = lvl + '/5'; };
    setFill();
    const W = 600, MID = 80;
    const draw = (now) => {
      const t = now / 1000;
      const env = ENV[pat] || ENV.steady;
      const amp = 10 + lvl * 11;
      const freq = pat === 'air' ? 0.03 : 0.035 + lvl * 0.012;
      const speed = pat === 'air' ? 2.2 : 6 + lvl * 2;
      let d = '';
      for (let x = 0; x <= W; x += 4) {
        const tt = t - (W - x) / 260;
        const e = env(tt);
        const y = MID + Math.sin(x * freq - t * speed) * amp * e;
        d += (x ? 'L' : 'M') + x + ' ' + y.toFixed(1);
      }
      line.setAttribute('d', d);
      ghost.setAttribute('d', d);
      if (orb) orb.style.setProperty('--amp', (1 + env(t) * (0.25 + lvl * 0.12) * (0.75 + 0.25 * Math.sin(t * 40))).toFixed(3));
    };
    let raf = 0, visible = false;
    let lastDraw = 0;
    // rezgés közben ritkábban rajzolunk (a főszál ne késleltesse a rezgés-időzítést és a „Megállítom” gombot)
    const loop = (now) => { if (!(buzzing && now - lastDraw < 90)) { draw(now); lastDraw = now; } raf = visible ? requestAnimationFrame(loop) : 0; };
    if (reduce) draw(1000);
    else if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => {
        visible = es[0].isIntersecting;
        if (visible && !raf) raf = requestAnimationFrame(loop);
      }).observe(vibe);
    } else { visible = true; raf = requestAnimationFrame(loop); }

    pats.forEach((b) => b.addEventListener('click', () => {
      pats.forEach((x) => x.setAttribute('aria-checked', String(x === b)));
      pat = b.dataset.ccpPat;
      if (reduce) draw(1000);
      if (buzzing) startBuzz();
    }));
    intEl.addEventListener('input', () => { lvl = Number(intEl.value) || 3; setFill(); if (reduce) draw(1000); });
    intEl.addEventListener('change', () => { if (buzzing) startBuzz(); });

    // ---- telefonon érezhető minta: Android = navigator.vibrate, iPhone/iPad = Safari kapcsoló-haptika + halk zümmögés ----
    const ua = navigator.userAgent || '';
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = 'vibrate' in navigator && /android/i.test(ua);
    const canBuzz = isAndroid || isIOS;
    let buzzing = false, buzzT = 0, stopT = 0, tickT = 0, seqT = 0;

    // A web csak be/ki kapcsolni tudja a motort (erősséget nem), és a telefonmotornak ~60 ms kell, hogy felpörögjön:
    // ezért hosszabb impulzusokkal dolgozunk; az erősséget a sűrűség (kitöltés) adja. Páros index = be, páratlan = ki (ms).
    const buildSeq = () => {
      const seq = [];
      const gap = Math.round(140 - lvl * 22);
      const off = Math.max(60, 300 - lvl * 40);
      if (pat === 'steady') seq.push(4500);
      else if (pat === 'pulse') { for (let k = 0; k < 9; k++) seq.push(260, off); }
      else if (pat === 'air') { for (let k = 0; k < 14; k++) seq.push(150, Math.max(60, 230 - lvl * 30)); }
      else if (pat === 'wave') { for (let k = 0; k < 6; k++) seq.push(120, gap, 260, gap, 480, gap, 260, gap); }
      else if (pat === 'heart') { for (let k = 0; k < 6; k++) seq.push(120, 90, 100, Math.max(260, 640 - lvl * 70)); }
      else if (pat === 'patter') { for (let k = 0; k < 28; k++) seq.push(70, Math.max(45, 120 - lvl * 14)); }
      else if (pat === 'steps') { for (let k = 0; k < 2; k++) seq.push(60, 220, 60, 220, 60, 220, 60, 220, 110, 130, 110, 130, 110, 130, 110, 130, 180, 70, 180, 70, 180, 70, 180, 70, 600, 300); }
      else { for (let k = 0; k < 3; k++) seq.push(80, 220, 140, 180, 260, 120, 420, 80, 700, 300); }
      return seq;
    };

    // iOS 17.4+ Safari: egy <input type=checkbox switch> átváltása rövid haptikus koppintást ad (csak felhasználói érintés után, némán is)
    let hapLab = null;
    const tick = () => {
      try {
        if (!hapLab) {
          const inp = document.createElement('input');
          inp.type = 'checkbox'; inp.id = 'ccpHap'; inp.setAttribute('switch', ''); inp.setAttribute('aria-hidden', 'true'); inp.tabIndex = -1;
          hapLab = document.createElement('label');
          hapLab.htmlFor = 'ccpHap'; hapLab.setAttribute('aria-hidden', 'true');
          const st = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
          inp.style.cssText = st; hapLab.style.cssText = st;
          document.body.appendChild(inp); document.body.appendChild(hapLab);
        }
        hapLab.click();
      } catch (e) {}
    };
    // halk zümmögés (Web Audio): a hangerő-kapcsoló / némító mód elnémítja, de a haptika attól még megy
    let actx = null, osc = null, gain = null;
    const hum = (on) => {
      try {
        if (!actx) {
          const AC = window.AudioContext || window.webkitAudioContext;
          if (!AC) return;
          actx = new AC();
          osc = actx.createOscillator(); gain = actx.createGain();
          osc.type = 'triangle'; osc.frequency.value = 96;
          gain.gain.value = 0;
          osc.connect(gain); gain.connect(actx.destination); osc.start();
        }
        if (actx.state === 'suspended') actx.resume();
        const g = Math.min(0.5, 0.06 + lvl * 0.07);
        gain.gain.cancelScheduledValues(actx.currentTime);
        gain.gain.setTargetAtTime(on ? g : 0, actx.currentTime, 0.012);
      } catch (e) {}
    };

    const stopBuzz = () => {
      buzzing = false; clearTimeout(buzzT); clearTimeout(stopT); clearTimeout(seqT); clearInterval(tickT);
      try { navigator.vibrate && navigator.vibrate(0); setTimeout(() => { try { navigator.vibrate(0); } catch (e) {} }, 60); } catch (e) {}
      if (humOn) hum(false);
      buzz.setAttribute('aria-pressed', 'false');
      if (buzzL) buzzL.textContent = 'Érezd a telefonodon';
    };
    let humOn = isIOS;
    // Android: saját ütemező – a hosszú „be” szakaszokat rövid impulzusokra bontjuk (PWM), így az erősség is állítható:
    // a kitöltés (be/ki arány) 25–100 %, 50 ms-os periódussal. Szünetben cancel.
    const DUTY = [0.25, 0.4, 0.58, 0.78, 1];
    const playIOS = (seq) => {
      let i = 0;
      const stepMs = Math.max(26, 78 - lvl * 11); // erősebb = sűrűbb koppintás
      const per = 50, onLen = Math.max(10, Math.round(per * DUTY[lvl - 1]));
      const next = () => {
        if (!buzzing || i >= seq.length) { if (buzzing) stopBuzz(); return; }
        const on = i % 2 === 0, d = seq[i++];
        clearInterval(tickT);
        if (humOn) hum(on);
        if (on && isIOS) { tick(); tickT = setInterval(tick, stepMs); }
        if (isAndroid) {
          try {
            if (!on) navigator.vibrate(0);
            else if (lvl >= 5) navigator.vibrate(d);
            else { navigator.vibrate(onLen); tickT = setInterval(() => { try { navigator.vibrate(onLen); } catch (e) {} }, per); }
          } catch (e) {}
        }
        seqT = setTimeout(next, d);
      };
      next();
    };
    const startBuzz = () => {
      clearTimeout(seqT); clearInterval(tickT);
      const seq = buildSeq();
      if (isAndroid) {
        let ok = false;
        try { navigator.vibrate(0); ok = navigator.vibrate(30); } catch (e) { ok = false; }
        if (!ok) {
          stopBuzz();
          if (buzzL) buzzL.textContent = 'A telefonod most nem enged rezgést';
          return;
        }
      }
      buzzing = true;
      buzz.setAttribute('aria-pressed', 'true');
      if (buzzL) buzzL.textContent = 'Megállítom';
      playIOS(seq);
      if (hint) hint.hidden = !isAndroid;
      clearTimeout(buzzT);
      buzzT = setTimeout(stopBuzz, 4500);
    };
    const lead = $('[data-ccp-vibe-lead]', root);
    // Androidon: ha a gomb után sem érződik rezgés (rezgés-beállítás, Ne zavarj, energiatakarékos mód), segítség + zümmögés
    let hint = null;
    if (isAndroid) {
      hint = document.createElement('p');
      hint.className = 'ccp-note';
      hint.hidden = true;
      hint.innerHTML = 'Nem érzed? Kapcsold be a telefonodon az <b>interaktív haptikus visszajelzést</b> (Pixelen: Beállítások → Hang és rezgés → Rezgés és haptika; más gyártóknál „érintési rezgés” vagy „haptikus visszajelzés” a neve), és kapcsold ki a <b>Ne zavarj</b> és az <b>Energiatakarékos</b> módot. <button type="button" class="ccp-link" data-ccp-hum>Zümmögéssel is</button>';
      buzz.insertAdjacentElement('afterend', hint);
      hint.addEventListener('click', (e) => {
        const b = e.target.closest('[data-ccp-hum]');
        if (!b) return;
        humOn = !humOn;
        b.textContent = humOn ? 'Zümmögés kikapcsolása' : 'Zümmögéssel is';
        if (!humOn) hum(false);
        if (buzzing) startBuzz();
      });
    }
    if (!canBuzz) {
      buzz.hidden = true;
      if (lead) lead.textContent = 'Válassz egy mintát és erősséget, és nézd meg, milyen ritmusban dolgozik.';
    } else {
      if (isIOS && lead) lead.textContent = 'Válassz egy mintát, és koppints az „Érezd a telefonodon” gombra – iPhone-on rövid, érezhető koppintásokat és halk zümmögést kapsz (iOS 17.4 vagy újabb, Safari).';
      buzz.addEventListener('click', () => (buzzing ? stopBuzz() : startBuzz()));
      document.addEventListener('visibilitychange', () => { if (document.hidden && buzzing) stopBuzz(); });
    }
  }

  /* ================= rezgés-diagnosztika (csak ?vibtest=1 esetén) ================= */
  if (/[?&]vibtest=1/.test(location.search) && 'vibrate' in navigator) {
    const box = document.createElement('div');
    box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99999;max-height:62vh;overflow:auto;padding:10px;border-radius:14px;background:#1d1317;color:#f1e5ea;font:12px/1.4 monospace;box-shadow:0 10px 40px rgba(0,0,0,.5)';
    box.innerHTML = '<b style="font:700 13px sans-serif">Rezgés-teszt</b> <button data-x style="float:right">×</button><div data-b style="display:flex;flex-wrap:wrap;gap:6px;margin:8px 0"></div><pre data-l style="margin:0;white-space:pre-wrap"></pre>';
    document.body.appendChild(box);
    const L = box.querySelector('[data-l]'), B = box.querySelector('[data-b]');
    const t0 = performance.now();
    const log = (m) => { L.textContent = '[' + Math.round(performance.now() - t0) + ' ms] ' + m + '\n' + L.textContent; };
    box.querySelector('[data-x]').onclick = () => box.remove();
    log('UA: ' + navigator.userAgent.slice(0, 110));
    log('aktív felhasználói tevékenység: ' + (navigator.userActivation ? navigator.userActivation.isActive : 'n/a') + ' · látható: ' + document.visibilityState);
    const btn = (label, fn) => { const b = document.createElement('button'); b.textContent = label; b.style.cssText = 'padding:8px 10px;border-radius:10px;border:1px solid #704b5e;background:#3e2933;color:#fff;font:600 12px sans-serif'; b.addEventListener('click', (e) => { log('koppintás-késés: ' + Math.round(performance.now() - e.timeStamp) + ' ms → ' + label); fn(); }); B.appendChild(b); };
    const V = (p) => { let r; try { r = navigator.vibrate(p); } catch (e) { r = 'hiba ' + e.message; } log('vibrate(' + JSON.stringify(p) + ') = ' + r); return r; };
    let tm = [];
    const stop = () => { tm.forEach(clearTimeout); tm = []; V(0); };
    btn('A: 1000 ms', () => { stop(); V(1000); });
    btn('B: 3×(300 be/300 ki) tömb', () => { stop(); V([300, 300, 300, 300, 300]); });
    btn('C: 5×(100/100) tömb', () => { stop(); V([100, 100, 100, 100, 100, 100, 100, 100, 100]); });
    btn('D: 5× külön vibrate(150) 400 ms-onként', () => { stop(); for (let i = 0; i < 5; i++) tm.push(setTimeout(() => V(150), i * 400)); });
    btn('E: PWM 20/30 ms ×30', () => { stop(); for (let i = 0; i < 30; i++) tm.push(setTimeout(() => V(20), i * 50)); });
    btn('F: 1,5 mp + kézi leállítás 0,5 mp-nél', () => { stop(); V(1500); tm.push(setTimeout(() => { const a = performance.now(); V(0); log('leállítás kiadva'); }, 500)); });
    btn('Leállít', () => { stop(); });
  }

  /* ================= méret-vizualizáló ================= */
  const size = $('[data-ccp-size]', root);
  if (size) {
    const OBJ = { card: { n: 'Bankkártya', v: 8.56, c: '' }, phone: { n: 'Okostelefon', v: 15, c: 'is-phone' }, banana: { n: 'Banán', v: 18, c: 'is-banana' } };
    const base = { len: parseFloat(root.dataset.len) || 0, dia: parseFloat(root.dataset.dia) || 0 };
    let lenLabel = 'behelyezhető';
    if (!base.len && facts.ins) base.len = facts.ins;
    if (!base.len && facts.tot) { base.len = facts.tot; lenLabel = 'teljes hossz'; }
    if (!base.dia && facts.dia) base.dia = facts.dia;
    const st = { len: base.len, dia: base.dia, objs: ['card'], last: 'card', tab: 'len' };
    const ruler = $('[data-ccp-ruler]', size), say = $('[data-ccp-say]', size);
    const circles = $('[data-ccp-circles]', size), pin = $('[data-ccp-scale-pin]', size);
    const note = $('[data-ccp-size-note]', size);
    const tabs = $$('[data-ccp-stab]', size), panels = $$('[data-ccp-spanel]', size);

    if (!st.len && !st.dia) { size.remove(); }
    else {
      size.hidden = false;
      const lenTab = tabs.find((t) => t.dataset.ccpStab === 'len');
      const diaTab = tabs.find((t) => t.dataset.ccpStab === 'dia');

      const renderLen = () => {
        if (!ruler) return;
        if (!st.len) { ruler.innerHTML = ''; return; }
        const vals = [st.len].concat(st.objs.map((k) => OBJ[k].v));
        const max = Math.max(10, Math.ceil(Math.max.apply(null, vals) / 5) * 5);
        const pct = (v) => (v / max * 100).toFixed(2) + '%';
        let h = '<div class="ccp-ruler__row"><span class="ccp-ruler__name">Ez a játék<br><small>' + lenLabel + '</small></span><div class="ccp-ruler__lane"><div class="ccp-ruler__bar is-prod" data-w="' + pct(st.len) + '"><span class="ccp-ruler__val">' + huNum(st.len) + ' cm</span></div></div></div>';
        st.objs.forEach((k) => {
          const o = OBJ[k];
          h += '<div class="ccp-ruler__row"><span class="ccp-ruler__name">' + o.n + '</span><div class="ccp-ruler__lane"><div class="ccp-ruler__bar is-obj ' + o.c + '" data-w="' + pct(o.v) + '"><span class="ccp-ruler__val">' + (k === 'card' ? '8,6' : '~' + huNum(o.v)) + ' cm</span></div></div></div>';
        });
        let ticks = '';
        for (let i = 0; i <= max; i++) {
          const major = i % 5 === 0;
          ticks += '<span class="' + (major ? 'is-major' : '') + '" style="left:' + pct(i) + '"></span>' + (major ? '<em style="left:' + pct(i) + '">' + i + '</em>' : '');
        }
        h += '<div class="ccp-ruler__ticks">' + ticks + '</div>';
        ruler.innerHTML = h;
        ruler.classList.remove('is-in');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          $$('.ccp-ruler__bar', ruler).forEach((b) => { b.style.width = b.dataset.w; });
          ruler.classList.add('is-in');
        }));
        if (say) {
          const o = OBJ[st.last] || OBJ.card;
          const r = st.len / o.v;
          say.innerHTML = r >= 0.95 && r <= 1.05
            ? 'Nagyjából <b>egy ' + o.n.toLowerCase() + '</b> hosszúságú.'
            : 'Nagyjából <b>' + huNum(r, 1) + ' ' + o.n.toLowerCase() + '</b> hosszú.';
        }
      };

      const COINS = [{ n: '100 Ft', s: 'érme', v: 2.38, c: 'is-coin' }, { n: '200 Ft', s: 'érme', v: 2.83, c: 'is-coin is-silver' }, { n: 'AA elem', s: 'átmérője', v: 1.45, c: 'is-coin is-silver' }];
      const renderDia = () => {
        if (!circles) return;
        if (!st.dia) { circles.innerHTML = '<p class="ccp-note">Ehhez a változathoz nincs megadva átmérő.</p>'; if (pin) pin.parentElement.parentElement.hidden = true; return; }
        if (pin) pin.parentElement.parentElement.hidden = false;
        const maxD = Math.max(st.dia, 2.83);
        const avail = Math.min(150, (circles.clientWidth || 320) * 0.42);
        const k = avail / maxD;
        const item = (lab, sub, v, cls) => '<div class="ccp-circ ' + cls + '"><i style="width:0;height:0" data-s="' + (v * k).toFixed(1) + '"></i><b>' + lab + '</b><small>' + sub + '</small></div>';
        circles.innerHTML = item('Ø ' + huNum(st.dia) + ' cm', 'ez a játék', st.dia, 'is-prod') + COINS.slice(0, 2).map((c) => item(c.n, 'Ø ' + huNum(c.v) + ' cm', c.v, c.c)).join('');
        requestAnimationFrame(() => requestAnimationFrame(() => { $$('.ccp-circ i', circles).forEach((i) => { i.style.width = i.dataset.s + 'px'; i.style.height = i.dataset.s + 'px'; }); }));
        // méretskála (Mini <2,5 · Kicsi 2,5–3 · Közepes 3,1–3,8 · Nagy 3,9–4,5 · XL >4,5)
        const B = [1, 2.5, 3.05, 3.85, 4.55, 7];
        let seg = 4;
        for (let i = 0; i < 5; i++) if (st.dia < B[i + 1]) { seg = i; break; }
        const frac = Math.max(0, Math.min(1, (st.dia - B[seg]) / (B[seg + 1] - B[seg])));
        if (pin) {
          pin.style.setProperty('--x', ((seg + frac) / 5 * 100).toFixed(1) + '%');
          $$('.ccp-scale__bar span', size).forEach((s, i) => s.classList.toggle('is-on', i === seg));
        }
      };

      // valós méret (kalibrálás bankkártyával)
      const cal = $('[data-ccp-cal]', size), calR = $('[data-ccp-calr]', size), calCard = $('[data-ccp-calcard]', size);
      const view = $('[data-ccp-realview]', size), canvas = $('[data-ccp-realcanvas]', size);
      let pxmm = parseFloat(store.get('cc_pxmm')) || 0;
      const setCal = (v) => { if (calCard) calCard.style.setProperty('--pxmm', v); if (calR) calR.style.setProperty('--fill', ((v - 2) / 6 * 100) + '%'); };
      const renderReal = () => {
        if (!canvas) return;
        const L = st.len * 10 * pxmm, D = (st.dia || 2.5) * 10 * pxmm;
        const cm = (10 * pxmm).toFixed(2);
        canvas.innerHTML =
          (st.dia ? '<div class="ccp-real__dia" style="width:' + D.toFixed(1) + 'px;height:' + D.toFixed(1) + 'px" title="Átmérő"><span>Ø ' + huNum(st.dia) + ' cm</span></div>' : '') +
          (st.len ? '<div class="ccp-real__len" style="width:' + L.toFixed(1) + 'px;height:' + Math.min(D, 90).toFixed(1) + 'px;--cm:' + cm + 'px"><span>' + huNum(st.len) + ' cm</span></div>' : '');
        let cap = view.querySelector('.ccp-real__cap');
        if (!cap) { cap = document.createElement('p'); cap.className = 'ccp-real__cap'; canvas.after(cap); }
        cap.textContent = '1:1 méretarány' + (st.len ? ' · hossz ' + huNum(st.len) + ' cm' : '') + (st.dia ? ' · átmérő ' + huNum(st.dia) + ' cm' : '') + (st.len && L > canvas.clientWidth ? ' · húzd oldalra' : '');
      };
      const showReal = () => {
        const ok = pxmm > 0;
        if (cal) cal.hidden = ok;
        if (view) view.hidden = !ok;
        if (ok) renderReal();
      };
      if (calR) {
        const start = pxmm || 3.78;
        calR.value = String(start); setCal(start);
        calR.addEventListener('input', () => setCal(calR.value));
      }
      const okBtn = $('[data-ccp-calok]', size);
      if (okBtn) okBtn.addEventListener('click', () => { pxmm = parseFloat(calR.value) || 3.78; store.set('cc_pxmm', String(pxmm)); showReal(); });
      const reBtn = $('[data-ccp-recal]', size);
      if (reBtn) reBtn.addEventListener('click', () => { pxmm = 0; showReal(); });

      const setTab = (k) => {
        st.tab = k;
        tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.ccpStab === k)));
        panels.forEach((p) => { p.hidden = p.dataset.ccpSpanel !== k; });
        if (k === 'len') renderLen();
        if (k === 'dia') renderDia();
        if (k === 'real') showReal();
      };
      tabs.forEach((t) => t.addEventListener('click', () => setTab(t.dataset.ccpStab)));
      $$('[data-ccp-obj]', size).forEach((b) => b.addEventListener('click', () => {
        const k = b.dataset.ccpObj;
        const on = b.getAttribute('aria-pressed') !== 'true';
        if (!on && st.objs.length === 1) return;
        b.setAttribute('aria-pressed', String(on));
        st.objs = on ? st.objs.concat(k) : st.objs.filter((x) => x !== k);
        st.objs.sort((a, c) => OBJ[a].v - OBJ[c].v);
        st.last = on ? k : st.objs[st.objs.length - 1];
        renderLen();
      }));

      const syncTabs = () => {
        if (lenTab) lenTab.hidden = !st.len;
        if (diaTab) diaTab.hidden = !st.dia;
        if (!st.len && st.tab === 'len') setTab('dia');
        else if (!st.dia && st.tab === 'dia') setTab('len');
        else setTab(st.tab);
        if (note) note.textContent = (st.len ? (lenLabel === 'teljes hossz' ? 'Teljes hossz: ' : 'Behelyezhető hossz: ') + huNum(st.len) + ' cm' : '') + (st.len && st.dia ? ' · ' : '') + (st.dia ? 'legnagyobb átmérő: ' + huNum(st.dia) + ' cm' : '') + (lenLabel !== 'választott méret' && !root.dataset.len && (facts.ins || facts.dia || facts.tot) ? ' · a gyártó adatai alapján' : '');
      };
      if (!st.len) st.tab = 'dia';
      size.addEventListener('ccp:in', syncTabs, { once: true });
      if (size.classList.contains('is-in') || !revealIO) syncTabs();

      // méret-változat (pl. „19,5 cm”) → hossz frissítése
      const vmap = json($('[data-ccp-variants]', root), {});
      const onVariant = () => {
        const f = $('.js-main-product-form input[name="id"]') || $('form[action*="/cart/add"] input[name="id"]');
        const v = f && vmap[f.value];
        if (!v) return;
        const sku = $('[data-ccp-sku]', root);
        if (sku && v.s) sku.textContent = v.s;
        const m = String(v.t || '').match(/(\d+(?:[.,]\d+)?)\s*cm/i);
        if (!m) return;
        const l = parseFloat(m[1].replace(',', '.'));
        if (!l || Math.abs(l - st.len) < 0.05) return;
        st.len = l;
        const same = base.len && Math.abs(l - base.len) < 0.3;
        lenLabel = same ? 'behelyezhető' : 'választott méret';
        st.dia = same ? base.dia : 0;
        syncTabs();
        const sl = stats && stats.querySelector('[data-k="len"]');
        if (sl) {
          const c = sl.querySelector('[data-ccp-count]'); if (c) { c.dataset.ccpCount = l; c.textContent = huNum(l); }
          const lb = sl.querySelector('[data-ccp-lenlab]'); if (lb) lb.textContent = same ? 'behelyezhető hossz' : 'választott méret';
        }
        const sd = stats && stats.querySelector('[data-k="dia"]');
        if (sd) sd.hidden = !same;
      };
      let lastV = '';
      const poll = () => {
        const f = $('.js-main-product-form input[name="id"]') || $('form[action*="/cart/add"] input[name="id"]');
        if (f && f.value !== lastV) { lastV = f.value; onVariant(); }
      };
      setInterval(poll, 500);
      poll();
    }
  }

  /* ================= lépések (mobil pöttyök) ================= */
  const steps = $('[data-ccp-steps]', root), snav = $('[data-ccp-stepsnav]', root);
  if (steps && snav) {
    const items = $$('.ccp-step', steps);
    snav.innerHTML = items.map(() => '<i></i>').join('');
    const dots = $$('i', snav);
    const mark = (i) => { dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); items.forEach((s, k) => s.classList.toggle('is-cur', k === i)); };
    mark(0);
    if ('IntersectionObserver' in window) {
      const vis = new Map();
      const io = new IntersectionObserver((es) => {
        es.forEach((en) => vis.set(en.target, en.intersectionRatio));
        let best = 0, max = 0;
        items.forEach((s, k) => { const r = vis.get(s) || 0; if (r > max) { max = r; best = k; } });
        if (max > 0.5) mark(best);
      }, { root: steps, threshold: [0.5, 0.75, 1] });
      items.forEach((s) => io.observe(s));
    }
  }

  /* ================= PDF méret ================= */
  $$('[data-ccp-doc]', root).forEach((a) => {
    fetch(a.href, { method: 'HEAD' }).then((r) => {
      const n = parseInt(r.headers.get('content-length'), 10);
      const meta = a.querySelector('[data-ccp-docmeta]');
      if (n && meta) meta.textContent = 'PDF, ' + (n > 1048576 ? huNum(n / 1048576, 1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB');
    }).catch(() => {});
  });

  /* ================= síkosító-választó ================= */
  const lopts = $$('[data-ccp-lube]', root);
  if (lopts.length) {
    const lpanels = $$('[data-ccp-lpanel]', root);
    lopts.forEach((b) => b.addEventListener('click', () => {
      lopts.forEach((x) => x.setAttribute('aria-selected', String(x === b)));
      lpanels.forEach((p) => { p.hidden = p.dataset.ccpLpanel !== b.dataset.ccpLube; });
    }));
  }

  /* ================= kosárba ================= */
  const notify = async (data) => {
    const noti = document.querySelector('ecx-cart-noti');
    const frm = document.querySelector('ecx-cart-drwr-frm');
    try {
      if (noti && typeof noti.renderContents === 'function') noti.renderContents(data);
      if (frm && typeof frm.renderContents === 'function') frm.renderContents(data);
      else if (data.sections && data.sections['cart-drawer']) {
        const liveW = document.querySelector('.js-cart-drawer-wrapper');
        const newW = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html').querySelector('.js-cart-drawer-wrapper');
        if (liveW && newW) liveW.innerHTML = newW.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'cc-pdp' } }));
    } catch (e) {}
  };
  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[data-ccp-add]');
    if (!btn || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    const label = btn.querySelector('[data-ccp-addl]');
    const orig = label ? label.textContent : '';
    btn.classList.add('is-busy');
    if (label) label.textContent = 'Hozzáadás…';
    try {
      const res = await fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(btn.dataset.variant), quantity: 1,
          properties: { _cc_pdp: (btn.dataset.src || 'similar') + ':' + (root.dataset.handle || '') },
          sections: 'cart-notification-panel-product,header-cart-status,cart-drawer',
          sections_url: location.pathname
        })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'add');
      if (!data.id) data.id = btn.dataset.variant;
      await notify(data);
      btn.classList.add('is-done');
      if (label) label.textContent = 'Kosárban';
      setTimeout(() => { btn.classList.remove('is-done'); if (label) label.textContent = orig; }, 2600);
    } catch (err) {
      if (label) label.textContent = 'Nem sikerült';
      setTimeout(() => { if (label) label.textContent = orig; }, 2200);
    } finally {
      btn.classList.remove('is-busy');
    }
  });

  /* ================= hasonlók: ajánlások + szűrő + összevetés ================= */
  const sim = $('[data-ccp-sim]', root);
  if (sim) {
    const track = $('[data-ccp-track]', sim);
    const empty = $('[data-ccp-empty]', sim);
    const fbtns = $$('[data-ccp-f]', sim);
    const cmpBox = $('[data-ccp-cmp]', sim), cmpTable = $('[data-ccp-cmptable]', sim);
    let filter = 'all';
    let picks = [];
    const MAX_DESK = 8;

    const tag = (c) => {
      const p = Number(c.dataset.price) || 0;
      const types = (c.dataset.tipus || '').split('|').filter(Boolean);
      c._type = types.some((t) => curTypes.includes(t));
      c._cheap = curPrice > 0 && p < curPrice * 0.9;
      c._prem = curPrice > 0 && p > curPrice * 1.15;
      c._brand = curVendor && (c.dataset.vendor || '').trim().toLowerCase() === curVendor;
      const b = c.querySelector('[data-ccp-badge]');
      if (b) {
        b.hidden = true; b.className = 'ccp-card__badge';
        if (c._type && c._prem) { b.hidden = false; b.textContent = 'Prémium'; }
        else if (c._type && c._cheap) { b.hidden = false; b.textContent = 'Kedvezőbb'; b.classList.add('is-cheap'); }
      }
    };
    const cards = () => $$('[data-ccp-card]', track);
    const match = (c) => filter === 'all' || (filter === 'type' && c._type) || (filter === 'cheap' && c._cheap) || (filter === 'premium' && c._prem) || (filter === 'brand' && c._brand);

    const applyFilter = (animate) => {
      const list = cards();
      const first = new Map();
      if (animate && !reduce && wide.matches) list.forEach((c) => { if (!c.classList.contains('is-hide')) first.set(c, c.getBoundingClientRect()); });
      let shown = 0;
      list.forEach((c) => {
        const ok = match(c);
        c.classList.toggle('is-hide', !ok);
        if (ok) { shown++; c.classList.toggle('is-more', shown > MAX_DESK); }
        else c.classList.remove('is-more');
      });
      if (empty) empty.hidden = shown > 0;
      if (moreBtn) moreBtn.hidden = !(wide.matches && shown > MAX_DESK && !sim.classList.contains('is-all'));
      if (!wide.matches) track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
      if (first.size) {
        list.forEach((c) => {
          if (c.classList.contains('is-hide')) return;
          const a = first.get(c), b = c.getBoundingClientRect();
          if (a) c.animate([{ transform: 'translate(' + (a.left - b.left) + 'px,' + (a.top - b.top) + 'px)' }, { transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' });
          else c.animate([{ opacity: 0, transform: 'scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'ease-out' });
        });
      }
    };
    const refreshChips = () => {
      const list = cards();
      const count = { type: 0, cheap: 0, premium: 0, brand: 0 };
      list.forEach((c) => { if (c._type) count.type++; if (c._cheap) count.cheap++; if (c._prem) count.premium++; if (c._brand) count.brand++; });
      fbtns.forEach((b) => {
        const k = b.dataset.ccpF;
        if (k === 'all') return;
        b.hidden = !(count[k] > 0 && count[k] < list.length);
      });
    };

    const moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'ccp-btn ccp-btn--ghost ccp-sim__more';
    moreBtn.textContent = 'Mutass többet';
    moreBtn.hidden = true;
    moreBtn.style.marginTop = '18px';
    track.after(moreBtn);
    moreBtn.addEventListener('click', () => { sim.classList.add('is-all'); moreBtn.hidden = true; });

    fbtns.forEach((b) => b.addEventListener('click', () => {
      filter = b.dataset.ccpF;
      fbtns.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      applyFilter(true);
    }));

    // összevetés
    const ROWS = [['p', 'Ár'], ['ty', 'Típus'], ['ve', 'Márka'], ['st', 'Stimuláció'], ['fu', 'Funkciók'], ['ma', 'Anyag'], ['le', 'Behelyezhető hossz'], ['di', 'Átmérő']];
    const val = (o, k) => {
      const v = o[k];
      if (v === '' || v == null) return '';
      if (k === 'p') return ft(v);
      if (k === 'le' || k === 'di') return huNum(v) + ' cm';
      return esc(v);
    };
    const renderCmp = () => {
      if (!cmpBox) return;
      if (!picks.length) { cmpBox.hidden = true; return; }
      const cols = [Object.assign({ cur: true }, current)].concat(picks.map((c) => { try { return JSON.parse(c.dataset.cmp); } catch (e) { return {}; } }));
      const minP = Math.min.apply(null, cols.map((c) => Number(c.p) || Infinity));
      let h = '<thead><tr><th></th>' + cols.map((c) => '<td class="' + (c.cur ? 'is-cur' : '') + '"><div class="ccp-cmp__p">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '') + (c.cur ? '<em>Ezt nézed</em>' : '') + '<b>' + (c.u ? '<a href="' + esc(c.u) + '">' + esc(c.t) + '</a>' : esc(c.t)) + '</b></div></td>').join('') + '</tr></thead><tbody>';
      ROWS.forEach(([k, lab]) => {
        if (!cols.some((c) => c[k] !== '' && c[k] != null)) return;
        h += '<tr><th>' + lab + '</th>' + cols.map((c) => '<td class="' + (c.cur ? 'is-cur ' : '') + (k === 'p' && Number(c.p) === minP && cols.length > 1 ? 'is-win' : '') + '">' + (val(c, k) || '–') + '</td>').join('') + '</tr>';
      });
      cmpTable.innerHTML = h + '</tbody>';
      const wasHidden = cmpBox.hidden;
      cmpBox.hidden = false;
      if (wasHidden) {
        const r = cmpBox.getBoundingClientRect();
        if (r.top > innerHeight - 80) cmpBox.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
      }
    };
    track.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ccp-cmpbtn]');
      if (!b) return;
      const c = b.closest('[data-ccp-card]');
      const on = b.getAttribute('aria-pressed') !== 'true';
      if (on) {
        picks.push(c);
        if (picks.length > 2) { const old = picks.shift(); old.classList.remove('is-cmp'); const ob = old.querySelector('[data-ccp-cmpbtn]'); if (ob) ob.setAttribute('aria-pressed', 'false'); }
      } else picks = picks.filter((x) => x !== c);
      b.setAttribute('aria-pressed', String(on));
      c.classList.toggle('is-cmp', on);
      renderCmp();
    });
    const clr = $('[data-ccp-cmpclear]', sim);
    if (clr) clr.addEventListener('click', () => {
      picks.forEach((c) => { c.classList.remove('is-cmp'); const b = c.querySelector('[data-ccp-cmpbtn]'); if (b) b.setAttribute('aria-pressed', 'false'); });
      picks = []; renderCmp();
    });

    const init = () => {
      cards().forEach(tag);
      refreshChips();
      applyFilter(false);
      if (!cards().length) sim.remove();
    };
    init();

    // Shopify ajánlások (related) – előre kerülnek, a kollekció-tartalék mögéjük
    const url = root.dataset.recos;
    if (url) {
      fetch(url).then((r) => (r.ok ? r.text() : '')).then((txt) => {
        if (!txt) return;
        const doc = new DOMParser().parseFromString(txt, 'text/html');
        const got = $$('[data-ccp-card]', doc);
        if (!got.length) return;
        const exist = new Map(cards().map((c) => [c.dataset.id, c]));
        const frag = document.createDocumentFragment();
        got.forEach((g) => {
          if (g.dataset.id === root.dataset.product) return;
          const old = exist.get(g.dataset.id);
          if (old) { old.dataset.reco = '1'; frag.appendChild(old); return; }
          const n = document.importNode(g, true); n.dataset.reco = '1'; frag.appendChild(n);
        });
        track.insertBefore(frag, track.firstChild);
        const curStim = String(current.st || '').split(', ').filter(Boolean);
        const score = (c, i) => {
          let d = {}; try { d = JSON.parse(c.dataset.cmp || '{}'); } catch (e) {}
          const types = (c.dataset.tipus || '').split('|');
          const st = String(d.st || '').split(', ').filter(Boolean);
          const p = Number(c.dataset.price) || 1;
          let s = 0;
          if (types.some((t) => curTypes.includes(t))) s += 4;
          s += st.filter((x) => curStim.includes(x)).length * 1.5;
          if (curStim.length && st.length && !st.some((x) => curStim.includes(x))) s -= 2;
          if (curVendor && (c.dataset.vendor || '').trim().toLowerCase() === curVendor) s += 0.8;
          if (curPrice) s -= Math.min(2, Math.abs(Math.log(p / curPrice)));
          if (c.dataset.reco) s += 1;
          return s - i * 0.01;
        };
        const ranked = cards().map((c, i) => [c, score(c, i)]).sort((a, b) => b[1] - a[1]).map((x) => x[0]);
        ranked.forEach((c) => track.appendChild(c));
        ranked.slice(12).forEach((c) => { if (!picks.includes(c)) c.remove(); });
        init();
      }).catch(() => {});
    }
  }

  /* ================= GYIK sima nyitás ================= */
  $$('.ccp-faq__item', root).forEach((det) => {
    const sum = det.querySelector('summary');
    if (!sum || reduce || !det.animate) return;
    let anim = null, closing = false;
    sum.addEventListener('click', (e) => {
      e.preventDefault();
      det.style.overflow = 'hidden';
      const from = det.getBoundingClientRect().height;
      if (anim) anim.cancel();
      let to, willOpen;
      if (det.open && !closing) { willOpen = false; closing = true; to = sum.getBoundingClientRect().height; }
      else { willOpen = true; closing = false; det.open = true; to = det.getBoundingClientRect().height; }
      anim = det.animate({ height: [from + 'px', to + 'px'] }, { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
      anim.onfinish = () => { if (!willOpen) det.open = false; closing = false; det.style.overflow = ''; anim = null; };
      anim.oncancel = () => { det.style.overflow = ''; };
    });
  });

  /* ================= ragadós fejezet-navigáció ================= */
  const nav = $('[data-ccp-nav]', root), navList = $('[data-ccp-navlist]', root);
  if (nav && navList) {
    const header = document.querySelector('ecx-header') || document.querySelector('.js-header');
    let chs = [];
    const build = () => {
      chs = $$('[data-ccp-ch]', root).filter((c) => !c.hidden && c.isConnected);
      navList.innerHTML = chs.map((c) => '<li><a href="#' + c.id + '">' + esc(c.dataset.ccpCh) + '</a></li>').join('');
      nav.hidden = chs.length < 3;
    };
    build();
    setTimeout(build, 1500);
    let tick = false, lastIdx = -2, lastTop = -1;
    const update = () => {
      tick = false;
      if (nav.hidden) return;
      const hb = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const top = Math.round(hb);
      if (top !== lastTop) { lastTop = top; root.style.setProperty('--top', top + 'px'); }
      const r = root.getBoundingClientRect();
      nav.classList.toggle('is-on', r.top < top + 40 && r.bottom > innerHeight * 0.5);
      let idx = -1;
      chs.forEach((c, i) => { if (c.getBoundingClientRect().top <= top + 140) idx = i; });
      if (idx !== lastIdx) {
        lastIdx = idx;
        const links = $$('a', navList);
        links.forEach((a, i) => { a.classList.toggle('is-active', i === idx); if (i === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        const act = links[idx];
        if (act) navList.scrollTo({ left: act.offsetLeft - navList.clientWidth / 2 + act.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
    };
    const req = () => { if (!tick) { tick = true; requestAnimationFrame(update); } };
    let follow = 0;
    const onScroll = () => {
      req();
      clearTimeout(follow);
      // a fejléc animálva csúszik be/ki: utána még néhányszor igazítunk
      follow = setTimeout(() => { req(); setTimeout(req, 220); setTimeout(req, 480); }, 120);
    };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', req);
    update();
    navList.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      const el = document.getElementById(a.getAttribute('href').slice(1));
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  // hajtás feletti kulcs-pirulák: sima görgetés (csak ha a cél létezik)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.ccp-key[href^="#"]');
    if (!a) return;
    const el = document.getElementById(a.getAttribute('href').slice(1));
    if (!el) { e.preventDefault(); const sp = document.getElementById('ccp-specifikacio'); if (sp) sp.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); return; }
    e.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();
